import { Box, Typography } from "@mui/material";

interface IndicatorProps {
  description?: string,
  color?: string,
  size?: number
}

const Indicator = (props: IndicatorProps) => {
  return (
    <Box p={1} sx={{
      width: 'fit-content',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }}
    >
      <span style={{ 
        width: props?.size ? props?.size : 8, 
        height: props?.size ? props?.size : 8, 
        backgroundColor: props?.color,
        borderRadius: '50%' 
        }}></span>
      {props?.description && <Typography ml={1} style={{ fontWeight: '500', fontSize: '12px' }}>{props?.description}</Typography>}
    </Box>
  );
};

export default Indicator;
